import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90c1f1c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["line", { active: _ctx.node.selected }]),
    style: _normalizeStyle({ paddingLeft: _ctx.node.level * 22 + 'px' }),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.node.select(!_ctx.node.selected)))
  }, [
    _createElementVNode("span", {
      class: "arrow",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.node.toggle()))
    }, [
      _withDirectives(_createVNode(_component_sc_icon, {
        type: _ctx.node.opened ? 'CaretRightOutlined' : 'CaretDownOutlined'
      }, null, 8, ["type"]), [
        [_vShow, _ctx.node.children.length > 0]
      ])
    ]),
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_component_a_checkbox, {
        checked: _ctx.node.checked === 'yes',
        indeterminate: _ctx.node.checked === 'half',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.node.check(_ctx.node.checked !== 'yes')))
      }, null, 8, ["checked", "indeterminate"])
    ]),
    (_ctx.menus.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : (_openBlock(), _createBlock(_component_a_dropdown, {
          key: 1,
          trigger: ['contextmenu']
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                    onClick: menu.handler,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(menu.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
          ]),
          _: 3
        }))
  ], 6))
}